import Grid from "@mui/material/Grid";
import { strLang } from "../../functions/strLang";
import { colorsList } from "../../data/colorsList";
import { GridItem } from "../../components/GridItem";

export default function AddressesList({ list, setSelectedPoint, setOpen }) {
  return (
    <Grid
      container
      spacing={5}
      padding={2}
      columns={{ xs: 1, sm: 8, md: 12, lg: 40 }}
    >
      {list.map((o, index) => (
        <Grid
          key={index}
          onClick={() => {
            setSelectedPoint({
              terId: o.IDTER,
              terName: o.NTER,
              point: o.PUNTO,
              name: o.NOM,
            });
            setOpen("openPoint");
          }}
          item
          xs={1}
          sm={4}
          md={4}
          lg={8}
        >
          <GridItem
            style={{ textAlign: "left", cursor: "pointer", height: "100%" }}
          >
            <b style={{ fontSize: "large", color: colorsList.blue }}>{o.NOM}</b>
            <div>[{o.NTER}]</div>
            <div>
              {strLang("point")}: {o.SEC}
            </div>
          </GridItem>
        </Grid>
      ))}
    </Grid>
  );
}
